import { useState, useEffect } from 'react'
import { useTranslations } from '@/utils/locale'
import ShieldLoader from '@/components/ui/shield-loader'

function HundioWidget() {
  const [isLoading, setIsLoading] = useState(true)
  const { t } = useTranslations()

  const i18n = {
    heading: t('Issues'),
    toggle: '${state}', // Other variables: percentUptime and incidentFreeStreak
    loading: t('Loading status...'),
    error: t('Connection error'),
    statistic: {
      streak: t('No events for ${duration}!'),
      uptime: t('${percent}% Uptime'),
    },
    issue: {
      scheduled: t('Scheduled'),
      empty: {
        operational: t('There are currently no reported issues.'),
        degraded: t(
          'There are currently no reported issues, but we have detected that at least one component is degraded.'
        ),
        outage: t('There are currently no reported issues, but we have detected outages on at least one component.'),
      },
    },
    state: {
      operational: t('Operational'),
      degraded: t('Degraded'),
      outage: t('Outage'),
      pending: t('Pending'),
      outOfOffice: t('Out of Office'),
    },
    linkBack: t('View Status Page'),
    dates: {
      locale: 'en-US',
      options: {},
    },
    time: {
      distanceInWords: {
        halfAMinute: t('half a minute'),
        lessThanXSeconds: {
          one: t('less than 1 second'),
          other: t('less than ${count} seconds'),
        },
        xSeconds: {
          one: t('1 second'),
          other: t('${count} seconds'),
        },
        lessThanXMinutes: {
          one: t('less than a minute'),
          other: t('less than ${count} minutes'),
        },
        xMinutes: {
          one: t('1 minute'),
          other: t('${count} minutes'),
        },
        aboutXHours: {
          one: t('about 1 hour'),
          other: t('about ${count} hours'),
        },
        xDays: {
          one: t('1 day'),
          other: t('${count} days'),
        },
        aboutXMonths: {
          one: t('about 1 month'),
          other: t('about ${count} months'),
        },
        xMonths: {
          one: t('1 month'),
          other: t('${count} months'),
        },
        aboutXYears: {
          one: t('about 1 year'),
          other: t('about ${count} years'),
        },
        overXYears: {
          one: t('over 1 year'),
          other: t('over ${count} years'),
        },
        almostXYears: {
          one: t('almost 1 year'),
          other: t('almost ${count} years'),
        },
      },
    },
  }

  useEffect(() => {
    const script = document.createElement('script')
    // self host https://libraries.hund.io/status-js/status-3.9.0.js
    script.src = '/js/hundio/status-3.9.0.js'
    script.async = true
    document.body.appendChild(script)
    script.onload = () => {
      if (window?.Status?.Widget) {
        new window.Status.Widget({
          hostname: 'https://status.bitwarden.com',
          selector: '#hundStatus',
          i18n,
        })
      }
      setIsLoading(false)
    }
  }, [])

  return (
    <>
      {isLoading && <ShieldLoader shieldSize="Xsmall" />}

      <div
        id="hundStatus"
        className="[&_div]:w-[240px]! [&_div]:z-10! dark:[&_>span]:text-white! [&_a]:text-primaryBlue [&_a]:py-2 [&_a]:text-sm"
      />
    </>
  )
}

export default HundioWidget
